import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

// This route protects public user pages (not admin)
const PublicProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const [status, setStatus] = useState(token ? 'checking' : 'unauthorized');

  useEffect(() => {
    if (!token) {
      setStatus('unauthorized');
      return;
    }
    // Optionally, you can verify token with backend here
    setStatus('authorized');
  }, [token]);

  if (status === 'checking') {
    return <div style={{ padding: '24px', textAlign: 'center' }}>Checking access...</div>;
  }

  if (status !== 'authorized') {
    return <Navigate to="/publicuser/login" replace />;
  }

  return children;
};

export default PublicProtectedRoute;
